export const emailRegex = /^(.+)@(\S+)\.(\S+)$/;
export const ibanRegex = /^[A-Z]{2}[0-9]{2}[0-9A-Z \t]{1,30}$/;

export const urlRegex =
  /^[a-z]+:\/\/[-a-zA-Z0-9+&@#/%?=~_|!:,.;]*[-a-zA-Z0-9+&@#/%=~_|]$/;

const minIbanLength = 1;
const maxIbanLength = 34;
const minBicLength = 8;
const maxBicLength = 11;
